import { defineComponent as _defineComponent } from 'vue'
import { ITicket } from '@/features/tickets/types'
import { mdiMinus, mdiPlus } from '@mdi/js'
import { ref, watch } from 'vue'
import { centsToDollars } from '@/services/currency'


export default /*#__PURE__*/_defineComponent({
  __name: 'PurchaseTicketItem',
  props: {
    ticket: null,
    checkboxMode: { type: Boolean },
    currentQuantity: null
  },
  emits: ["update:quantity"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:quantity', ticketId: number, quantity: number): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  ticket: ITicket
  checkboxMode?: boolean
  currentQuantity?: number
};





const quantity = ref(props.currentQuantity || 0)

watch(
  () => props.currentQuantity,
  (newQuantity) => {
    quantity.value = newQuantity || 0
  }
)

const increment = () => {
  if (props.checkboxMode) return
  if (props.ticket.remaining === quantity.value) return
  quantity.value += 1
  emit('update:quantity', props.ticket.id, quantity.value)
}

const decrement = () => {
  if (props.checkboxMode) return
  if (quantity.value === 0) return
  quantity.value -= 1
  emit('update:quantity', props.ticket.id, quantity.value)
}

const toggleCheckbox = () => {
  if (!props.checkboxMode) return
  quantity.value = quantity.value === 0 ? 1 : 0
  emit('update:quantity', props.ticket.id, quantity.value)
}

return { __sfc: true,props, emit, quantity, increment, decrement, toggleCheckbox, mdiMinus, mdiPlus, centsToDollars }
}

})